import React, {useState} from 'react';
import {Button, Col, Container, FormControl, FormLabel, Modal, Row} from "react-bootstrap";
import useCompanyId from "../../Hooks/useCompanyId";
import {useTranslation} from "react-i18next";
import ConditionalRender, {Fallback} from "../ConditionalRender";
import LoadingSpinner from "../Loading/LoadingSpinner";
import {createWorkOrderForCompany} from "../../API/companyApi";
import {toast} from "react-toastify";
import messageFromError from "../../utils/errorUtils";
import {formatDateForDateInput} from "../../utils/DateTimeUtills";

const RegisterWorkOrderModal = ({active, onCancel, onSuccess, assignToGeofence}) => {
    const companyId = useCompanyId()
    const {t} = useTranslation()

    const [workOrderName, setWorkOrderName] = useState('')
    const [workOrderKey, setWorkOrderKey] = useState('')
    const [from, setFrom] = useState(new Date())
    const [to, setTo] = useState(() => {
        const now = new Date();
        now.setMinutes(0);
        now.setSeconds(0);

        const to = new Date(now);
        to.setFullYear(to.getFullYear() + 1);
        return to;
    })

    const [showSpinner, setShowSpinner] = useState(false)
    const createWorkOrder = async () => {
        setShowSpinner(true)
        try {
            await createWorkOrderForCompany(companyId, {name: workOrderName, key: workOrderKey, assignment: {geofenceId: assignToGeofence.id, from: from, to: to}})
            toast.success(t('dialogs.notifications.created'))
            return true;
        }
        catch (error) {
            toast.error(messageFromError(error))
            return false;
        }
        finally {
            setShowSpinner(false)
        }
    }

    const resetModal = () => {
        setWorkOrderName('')
        setWorkOrderKey('')
        setFrom(new Date())
        setTo(() => {
            const now = new Date();
            now.setMinutes(0);
            now.setSeconds(0);

            const to = new Date(now);
            to.setFullYear(to.getFullYear() + 1);
            return to;
        })
    }

    const handleSaveAndAddAnother = async ()  => {
        const success = await createWorkOrder();
        if(success)
            resetModal()
    }

    const handleSaveAndClose = async () => {
        const success = await createWorkOrder();
        if(success)
        {
            resetModal()
            onSuccess()
        }
    }

    return (
        <Modal centered show={active} onHide={() => {!showSpinner && onCancel()}} size={'lg'}>
            <Modal.Header className='modal-header' closeButton={true}>
                <Modal.Title>{t('pages.workOrders.newWorkOrderDialog.title') + assignToGeofence?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormLabel>{t('pages.workOrders.newWorkOrderDialog.name')}</FormLabel>
                <FormControl required type='text' value={workOrderName} placeholder={t('pages.workOrders.newWorkOrderDialog.namePlaceholder')} onChange={(e) => {setWorkOrderName(e.target.value)}} />
                <FormLabel className='mt-2'>{t('pages.workOrders.newWorkOrderDialog.key')} <span className={'text-danger'}>*</span></FormLabel>
                <FormControl required type='text' value={workOrderKey} placeholder={t('pages.workOrders.newWorkOrderDialog.keyPlaceholder')} onChange={(e) => {setWorkOrderKey(e.target.value)}} />

                <ConditionalRender condition={assignToGeofence}>
                    <div className={'d-flex align-items-center justify-content-between'}>
                        <div className={'w-100 me-1'}>
                            <FormLabel className={'mt-2'}>{t("global.time.from")}</FormLabel>
                            <FormControl required type='datetime-local' value={formatDateForDateInput(from)} onChange={(e) => setFrom(new Date(e.target.value))} />
                        </div>
                        <div className={'w-100 ms-1'}>
                            <FormLabel className={'mt-2'}>{t("global.time.to")}</FormLabel>
                            <FormControl required type='datetime-local' value={formatDateForDateInput(to)} onChange={(e) => setTo(new Date(e.target.value))} min={formatDateForDateInput(from)} />
                        </div>
                    </div>
                </ConditionalRender>
            </Modal.Body>
            <Modal.Footer>
                <Container fluid>
                    <Row>
                        <Col md={4}>
                            <Button variant={'danger'} onClick={() => onCancel()}>{t('global.operations.cancel')}</Button>
                        </Col>
                        <Col className={'d-flex justify-content-end'}>
                            <ConditionalRender condition={!showSpinner}>
                                <Fallback><LoadingSpinner variant={"success"}/></Fallback>

                                <Button variant='success' onClick={handleSaveAndAddAnother} className={'me-1'}>{t('pages.workOrders.newWorkOrderDialog.saveAndAddAnother')}</Button>
                                <Button variant='success' onClick={handleSaveAndClose}>{t('pages.workOrders.newWorkOrderDialog.saveAndClose')}</Button>
                            </ConditionalRender>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
        // </ActionModal>
    );
};

export default RegisterWorkOrderModal;